
<script setup>

const { stat } = defineProps( [ 'stat' ] )

const { icon, statistic } = stat

</script>

<template>

  <div class="flex gap-2 py-5 @container">

    <img :src="icon" :alt="statistic + ' icon'" class="w-6 h-6 hidden @xs:block" />

    <p class="capitalize">{{ statistic }}&colon;</p>

    <span class="font-bold">{{ stat.value }}</span>

  </div>

</template>